<template>
    <div class="row justify-content-md-center">
        <div class="col-md-8">
            <h3 class="text-center text-muted">{{ titulo_span }}</h3>
            <b-progress :max="max" class="mb-3" v-if="this.asistente_step != 'avaluo'">
                <b-progress-bar
                    v-if="marca_name"
                    variant="danger"
                    :value="values"
                    class="bar-status"
                ></b-progress-bar>
                <b-progress-bar
                    v-if="modelo"
                    variant="danger"
                    :value="values"
                    class="bar-status"
                ></b-progress-bar>
                <b-progress-bar
                    v-if="linea_name"
                    variant="danger"
                    :value="values"
                    class="bar-status"
                ></b-progress-bar>
                <b-progress-bar
                    v-if="version_name"
                    variant="danger"
                    :value="values"
                    class="bar-status"
                ></b-progress-bar>
                <b-progress-bar
                    v-if="color"
                    variant="danger"
                    :value="values"
                    class="bar-status"
                ></b-progress-bar>
                <b-progress-bar
                    v-if="kilometraje"
                    variant="danger"
                    :value="values"
                ></b-progress-bar>
            </b-progress>
            <div class="row mt-4" v-if="this.asistente_step != 'avaluo'">
                <div class="col-auto">
                    <a
                        @click="back()"
                        class="text-danger"
                        data-toggle="tooltip"
                        title="Volver"
                        v-if="this.asistente_step != ''"
                    >
                        <i
                            class="fa fa-chevron-left fa-2x"
                            aria-hidden="true"
                        ></i>
                    </a>
                </div>
                <div class="col">
                    <h6 class="text-center mb-0">
                        <span
                            v-if="marca_name"
                            class="text-uppercase font-weight-bold"
                        >
                            {{ `${marca_name} - ` }}
                        </span>
                        <span
                            v-if="modelo"
                            class="text-uppercase font-weight-bold"
                        >
                            {{ `${modelo} - ` }}
                        </span>
                        <span
                            v-if="linea_name"
                            class="text-uppercase font-weight-bold"
                        >
                            {{ `${linea_name} - ` }}
                        </span>
                        <span
                            v-if="version_name"
                            class="text-uppercase font-weight-bold"
                        >
                            {{ `${version_name} - ` }}
                        </span>
                        <span
                            v-if="color"
                            class="text-uppercase font-weight-bold"
                        >
                            {{ `${color} - ` }}
                        </span>
                        <span
                            v-if="kilometraje"
                            class="font-weight-bold"
                        >
                            {{ `${numberWithDots(kilometraje)} km` }}
                        </span>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
    data() {
        return {
            values: 16.6,
            max: 100
        };
    },
    computed: {
        ...mapFields("vender", [
            "asistente_step",
            "titulo_span",
            "selection_data.marca_name",
            "selection_data.modelo",
            "selection_data.linea_name",
            "selection_data.version_name",
            "selection_data.color",
            "selection_data.kilometraje",
            "selection_data.datos",
        ])
    },
    methods: {
        numberWithDots: stringReal => {
            var toInt = parseInt(stringReal);
            var roundedValue = Math.round(toInt);
            return roundedValue
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        back() {
            switch (this.asistente_step) {
                case "modelo":
                    this.asistente_step = "";
                    break;
                case "linea":
                    this.asistente_step = "modelo";
                    this.titulo_span = "Seleccione el modelo...";
                    break;
                case "version":
                    this.asistente_step = "linea";
                    this.titulo_span = "Seleccione la linea...";
                    break;
                case "color":
                    this.asistente_step = "version";
                    this.titulo_span = "Seleccione la version...";
                    break;
                case "kilometraje":
                    this.asistente_step = "color";
                    this.titulo_span = "Seleccione el color...";
                    break;
                case "datos":
                    this.asistente_step = "kilometraje";
                    this.titulo_span = "Ingrese el kilometraje...";
                    break;
                default:
                    break;
            }
        }
    }
};
</script>

<style lang="scss">
.progress {
    height: 0.4rem;
}
.progress-bar.bar-status.bg-danger {
    margin-right: 10px;
}
</style>
